import React, { createContext, useContext, useEffect, useState } from "react";
import { apiFetch } from "../../api/apiClient";

// Create Context
const PortfolioDataContext = createContext({ data: [] });

// Custom hook for easy access
export const usePortfolioData = () => useContext(PortfolioDataContext);

// Provider component
export const PortfolioDataProvider = ({ children }) => {

  const [data, setData] = useState([]);
  const loadData = async () => {
    try {
      const response = await apiFetch("/api/metrics/portfolios");
      setData(Array.isArray(response) ? response : []);
    } catch (apiError) {
      console.warn("API fetch failed, falling back to local file:", apiError);

      try {
        const res = await fetch(
          new URL("/data/PortfolioData.json", window.location.origin)
        );
        if (!res.ok) {
          throw new Error(`Local fallback returned ${res.status}`);
        }
        const json = await res.json();
        setData(Array.isArray(json) ? json : []);
      } catch (localError) {
        console.error("Both API and local fetch failed:", localError);
        setData([]);
      }
    }
  };

  useEffect(() => {
    loadData();
  }, []);

  return (
    <PortfolioDataContext.Provider value={{ data }}>
      {children}
    </PortfolioDataContext.Provider>
  );
};
